<rr-icon
  class="bell pointer"
  name="bell"
  [counter]="unreadCounter"
  color="nutral"
></rr-icon>
<div class="messagelist col" *ngIf="messages.length > 0">
  <div
    class="messageitem row space-between gap-8 w100 align-center"
    (blur)="setAllToClosed()"
    [ngClass]="
      (m.open === false || !m.open) && m.isRead == 0 ? 'unread' : 'read'
    "
    *ngFor="let m of messages"
  >
    <div class="row gap-8 align-center" *ngIf="m.open === true">
      @if(m.fromId === 'SYSTEM'){
      <img
        src="images/default-agent.png"
        class="avatar"
        title="Jonny Futureson"
      />
      }@else {
      <img
        class="avatar"
        [src]="
          serverurl +
            '/public/avatars/' +
            m.fromId +
            '.png?' +
            m.refreshtoken || ''
        "
        alt="User Avatar"
      />
      }
      <div class="col">
        <span class="strong">{{ m.message.headline }}</span>
        <span>{{ m.message.message }}</span>
      </div>
    </div>

    <div *ngIf="m.open === false || !m.open">
      <div class="row gap-8 align-center">
        <rr-icon
          name="check"
          color="nutral"
          class="small"
          *ngIf="m.isRead == 1"
        ></rr-icon>
        <div class="strong">{{ m.message.headline }}</div>
      </div>
    </div>

    <div class="row">
      <rr-icon
        name="external_link"
        color="nutral"
        class="pointer small"
        (click)="markAsReadAndOpen(m)"
        *ngIf="(m.open === false || !m.open) && m.isRead == 0"
      ></rr-icon>
      <rr-icon
        name="trash"
        color="nutral"
        class="pointer small"
        (click)="deleteMessage(m)"
        *ngIf="m.open === true || m.isRead == 1"
      ></rr-icon>
    </div>
  </div>
</div>
